import { render, staticRenderFns } from "./TacoRating.vue?vue&type=template&id=db4ac2ee&scoped=true&"
import script from "./TacoRating.vue?vue&type=script&lang=js&"
export * from "./TacoRating.vue?vue&type=script&lang=js&"
import style0 from "./TacoRating.vue?vue&type=style&index=0&id=db4ac2ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4ac2ee",
  null
  
)

export default component.exports